import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Coffee interface",
  "description": "",
  "published": "2007-05-30T00:00:00.000Z",
  "redirect_from": ["/blog/coffee-interface/swizec/197"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`This video shows the future. It is a 20 year old future, but still the future even now. It's a coffee table, display, user interface hybrid and I believe it's looking very useful. Due to posture issues it can never replace a computer, but for a tool at meetings and such it definitely looks awesome.`}</p>
    <p>{`Wonder what happens when you spill the coffee though.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      